/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { NotificationKindInfo } from './notificationKindInfo';
import type { AvailableNotificationsResponsePreferences } from './availableNotificationsResponsePreferences';

export interface AvailableNotificationsResponse {
  channels?: string[];
  kinds?: NotificationKindInfo[];
  preferences?: AvailableNotificationsResponsePreferences;
}
